import type { ScriptElement } from '@/features/studio/script/script-elements'
import type { ScriptConvention } from '@/features/studio/script/useScriptFormatPrefs'
import { serializeElementsStandard } from '@/features/studio/script/script-format-standard'

export function serializeElementsToFountain(
  elements: ScriptElement[],
  convention: ScriptConvention = 'cn',
): string {
  return serializeElementsStandard(elements, convention)
}
